import Offline from './Offline';

export default Offline;
